import { Directive, Input } from '@angular/core';

@Directive({
	selector: '[smFilterControlLabel]',
	exportAs: 'smFilterControlLabel'
})
export class SmFilterControlLabelDirective {
	@Input() label: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/directives/sm-filter-control-label.directive.ts